import React from 'react'
import {useSelector} from 'react-redux'
import {selectOrderMode} from '../../../../../app-store/PurchaseLinkSlice'
import {ParentPayOrderSummary} from './ParentPayOrderSummary'
import {LocationOrderSummary} from './LocationOrderSummary'

// Analog of ProposalTool's OrderSummary page. Purely a dispatcher: in the
// account-header "Create Purchase Link" flow (orderMode === 'parentPay') it
// renders every parent-pay location as a combined summary (ParentPayOrderSummary
// / MultiLocationOrderSummaryContainer); otherwise it renders the single active
// location (LocationOrderSummary / OrderSummaryContainer). Checkout/link
// submission is out of scope for this flow — no send/save actions here, just
// live totals.
//
// Each branch owns its own usePurchaseLinkProducts/usePurchaseLinkPaymentPreview
// calls so only the active branch's instance actually runs — previously both
// hooks ran here unconditionally before the orderMode check, so the parentPay
// path always paid for a second, discarded useCatalogCart/payment-preview
// instance (duplicate ValidUrlExtension/MCVasItemList/preview-payment calls).
export function OrderSummary({actions}) {
  const orderMode = useSelector(selectOrderMode)
  if (orderMode === 'parentPay')
    return <ParentPayOrderSummary actions={actions} />
  return <LocationOrderSummary actions={actions} />
}
